import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Bulk validate drivers by their ID.
 *
 * @private
 */
export const validateDriverDelete = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.server.rm.DeleteDriverValidationResults,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/driver/validateDelete', async (driverIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/driver/validateDelete', {
      category: 'rpc',
      type: 'rpc/driver/validateDelete',
      driverIds,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {validateDriverDelete}`,
      { tags: ['rpc', 'driver'], info: driverIds },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Validating drivers deletion [${driverIds}] Failed`,
      error,
    })
  }
})
